$(function() {
  "use strict";
  
  if ($('.section-product-page').length > 0) {
  	product.init();
    
  }
  
  if ($('.js-recent').length > 0) {
    recentlyViewed.init();
  }
  
  if ($('.js-product').hasClass('floating-add-to-cart')) {
    $(window).on('scroll', function() {
      var add_to_cart_distance = $('.desktop-add-to-cart').offset().top;
      var current_distance = $(window).scrollTop();
      //console.log('Window:'+current_distance);
      //console.log('Cart:'+add_to_cart_distance);
      if(current_distance > add_to_cart_distance) {
      	$('.mobile-form-actions').show();
      } else {
      	$('.mobile-form-actions').hide();
      }
    });
  }
  
});

var product = {
  init: function() {
    var numberOfSlidesMobile = $('.main-images').data('number-of-slides');
    var mobileDots = $('.secondary-images').data('mobile-dots');
  	$('.main-images').slick({
      "lazyLoad": 'progressive',
      arrows: false,
      "adaptiveHeight": false,
      "infinite": false,
      asNavFor: '.secondary-images',
      focusOnSelect: true,
      responsive: [
        {
          breakpoint: 640,
          settings: {
            slidesToShow: numberOfSlidesMobile,
            slidesToScroll: numberOfSlidesMobile,
            infinite: false,
            dots: mobileDots
          }
        }
      ]
    });
    if ($('.main-images').data('enlarge') == 'zoom') {
      product.zoom($('.main-images .slide:eq(0) a'));
      $('.main-images').on('beforeChange', function(event, slick, currentSlide, nextSlide){
        product.zoom($('.main-images .slide:eq('+nextSlide+') a'));
      });
    }
    
    $('.vertical .secondary-images').slick({
      "lazyLoad": 'progressive',
      "adaptiveHeight": true,
      arrows: false,
      dots: false,
      "infinite": false,
      "vertical": true,
      "verticalSwiping": true,
      "slidesToShow": 4,
  	  "slidesToScroll": 1,
      "asNavFor": '.main-images',
      "focusOnSelect": true,
      "customHeightMatching": true,
      "customSlideAdvancement": true,
      responsive: [
        {
          breakpoint: 640,
          settings: {
            "vertical": false,
      		"verticalSwiping": false,
            "customHeightMatching": false,
      		"customSlideAdvancement": false,
          }
        }
      ]
    });
    
    $('.horizontal .secondary-images').slick({
      "lazyLoad": 'progressive',
      "adaptiveHeight": true,
      arrows: false,
      dots: false,
      "infinite": false,
      "vertical": false,
      "verticalSwiping": false,
      "slidesToShow": 4,
  	  "slidesToScroll": 1,
      "asNavFor": '.main-images',
      "focusOnSelect": true,
      "customHeightMatching": false,
      "customSlideAdvancement": true
    });
    
    $(".js-product .product-form-with-options").each(function() {
     new Shopify.OptionSelectors($('.product-form-with-options').data("select-id"), { product: $('.product-form-with-options').data("product"), onVariantSelected: onVariantSelect, enableHistoryState: $(this).data("enable-state") });
    });
    
    
      $('body').on('change', '.swatch :radio', function() {
        var optionIndex = $(this).closest('.swatch').attr('data-option-index');
        var optionValue = $(this).val();
        var parentForm = $(this).closest('.product-form');

        var option1 = parentForm.find('.swatch_options input:checked').eq(0).val();
        var option2 = parentForm.find('.swatch_options input:checked').eq(1).val() || '';
        var option3 = parentForm.find('.swatch_options input:checked').eq(2).val() || '';
        
        $(this)
          .closest('form')
          .find('.single-option-selector')
          .eq(optionIndex)
          .val(optionValue)
          .trigger('change');
      });
    
    
    if($('.upsell-product-slider').length > 0 && $('.js-product').data('upsell') === 'page') {
    	$('.upsell-product-slider').slick({
          "lazyLoad": 'progressive',
          "adaptiveHeight": true,
          arrows: false,
          dots: true,
          "infinite": false,
          "vertical": false,
          "verticalSwiping": false,
          "slidesToShow": 3,
          "slidesToScroll": 1,
          "focusOnSelect": true,
          "customSlideAdvancement": false,
          responsive: [
            {
              breakpoint: 960,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                infinite: false,
                dots: true
              }
            }
          ]
        });
    }
    
    if($('.related-slider').length > 0) {
      	var slidesToShow = $('.related-slider').data('slides-to-show');
    	$('.related-slider').slick({
          "lazyLoad": 'progressive',
          "adaptiveHeight": true,
          arrows: false,
          dots: true,
          "infinite": false,
          "vertical": false,
          "verticalSwiping": false,
          "slidesToShow": slidesToShow,
          "slidesToScroll": 1,
          "focusOnSelect": true,
          "customSlideAdvancement": false,
          responsive: [
            {
              breakpoint: 960,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                infinite: false,
                dots: true
              }
            }
          ]
        });
    }
  },
  quantity: function(){
    $('body').on('click', '.js-change-quantity', function() {
        var $this = $(this),
            $input = $(this).siblings('input'),
            val = parseInt($input.val()),
            valMax = 100000000000000000000000000000,
            valMin = $input.attr('min') || 0;

        if ($input.attr('max') != null){
          valMax = $input.attr('max');
        }

        if(isNaN(val) || val < valMin) {
            $input.val(valMin);
            return false;
        } else if (val > valMax) {
            $input.val(valMax);
            return false;
        }

        if($this.data('func') == 'plus') {
          if(val < valMax) { 
            $input.val(val + 1);
          }
        } else {
          if(val > valMin) { 
            $input.val(val - 1);
          }
        }
        $input.trigger('change');

    });
  },
  zoom: function($link) {
  	var largeImage = $link.data('zoom');
    $link.on('click', function(e){
      e.preventDefault();
    });
    $link.zoom({
      on: 'click',
      url: largeImage, 
      onZoomIn: function() {
        $(this).addClass('photo-zoom-linked');
      },
      onZoomOut: function() {
        $(this).removeClass('photo-zoom-linked');
      }
    });
  }
}

var recentlyViewed = {
  init: function(){
  	var productHandle,
        rCookie,
        rProducts,
        displayProducts,
        rProductArray;
    
    if ($('.js-product[data-recent]').length){
      productHandle = $('.js-product').data('recent').toString();
      rCookie = Cookies.get('recentlyViewed');
      rProducts = recentlyViewed.getCookieProducts(rCookie, productHandle);
    }
    
    if (rProducts){
      rProductArray = unescape(rProducts).split(',');
    }
    
    if (productHandle){
      if(!$.inArray(productHandle, rProductArray) !== -1){
        displayProducts = [];
        rProductArray.unshift(productHandle);
        $.each(rProductArray, function(i, el){
            if($.inArray(el, displayProducts) === -1) displayProducts.push(el);
        });
      }
      recentlyViewed.setCookieProducts(displayProducts);
    } else {
      displayProducts = rProductArray;
    }
    
    if ($('.js-recent').length){
      var parent = '.js-recent';
      recentlyViewed.getProductInformation(parent, displayProducts, productHandle);
    }
  },
  getCookieProducts: function(rCookie, productHandle){
    if (!rCookie && productHandle) {
      Cookies.set('recentlyViewed', productHandle, { expires: 30, path: '/' });
      rCookie = Cookies.get('recentlyViewed');
    } else {
      rCookie = Cookies.get('recentlyViewed');
    }
    return rCookie;
  },
  setCookieProducts: function(rProductArray){
    Cookies.set('recentlyViewed', escape(rProductArray.join(',')), { expires: 30, path: '/' });
  },
  getProductInformation: function(parent, displayProducts, productHandle){

    if (productHandle){
      displayProducts.splice( $.inArray(productHandle, displayProducts), 1 );
    }

    var productLimit = $(parent).data('limit');

    if (productLimit && displayProducts){
      displayProducts = displayProducts.slice(0, productLimit);
    }

    $.each(displayProducts, function (index, value) {

      if (value){
        $(parent).removeClass('uk-hidden');

        $.ajax({
          type: 'GET',
          url: '/products/' + value  + '?view=r',
          success: function(data) {
            var rProduct = $(data).find('.js-recent-product');
            var qs = $(data).find('.quick-shop-modal').attr('id');
            
            //Remove modals if they already exist. They will be added bellow
            if($('#'+qs).length > 0) {
            	$('#'+qs).remove();
            }
            
            $(parent).find(' .r-item-' + index ).append(rProduct);
            //Currencies
            
            
        
           },
           error: function(x, t, m) {
            console.log(x);
            console.log(t);
            console.log(m);
           },
           dataType: "html"
        });
      }
    });
    
    if ($('.recent-slider').length > 0){
      if (displayProducts.length <= productLimit) {
        $('.recent-slider .slide').eq(displayProducts.length-1).nextAll().remove();
        $('.recent-slider .r-item').eq(displayProducts.length).nextAll().addBack().remove();
      } else {
        $('.recent-slider .r-item').eq(productLimit).nextAll().addBack().remove();
      }
       
      if ($('.recent-slider').hasClass('slick-initialized') == false){
        recentlyViewed.createSlider(parent, productLimit);
      }
    } else {
      if (displayProducts.length <= productLimit) {
        $('.section-recent-products .r-item').eq(displayProducts.length).nextAll().addBack().remove();
      } else {
        $('.section-recent-products .r-item').eq(productLimit).nextAll().addBack().remove();
      }
    }
  },
  createSlider: function(parent, productLimit) {
    var slidesToShow = $('.recent-slider').data('slides-to-show');

    $('.recent-slider').slick({
      "lazyLoad": 'progressive',
      "adaptiveHeight": true,
      arrows: false,
      dots: true,
      "infinite": false,
      "vertical": false,
      "verticalSwiping": false,
      "slidesToShow": slidesToShow,
      "slidesToScroll": 1,
      "focusOnSelect": true,
      "customSlideAdvancement": false,
      responsive: [
        {
          breakpoint: 1400,
          settings: {
            slidesToShow: 5,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 960,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 640,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        }
      ]
    });
  }
}

onVariantSelect = function(variant, selector) {
  var $product = $('.product-' + selector.product.id +' #product-details');
  var $notifyForm = $('.notify-form-' + selector.product.id);
  var $productForm = $('form.product-form', $product);
  var enableInventory = $productForm.data('enable-inventory');
  
  if (enableInventory == true) {
    //Manage Inventory
    var inventory_quantity = $('.product-form__variants option[value="'+variant.id+'"]', $product).data('variant-inventory');
    if (inventory_quantity == 1) {
      var pluralize_product = 'product';
    } else {
      var pluralize_product = 'products';
    }

    var hurry_only = 'Hurry!! Only';
    var products_left_in_stock = 'left';

    if(inventory_quantity >= 100) {
      if (variant.available == true) {
        $('.progress-wrapper', $product).removeClass('uk-hidden');
        $('.stock-qty-wrapper', $product).empty().append('We just restocked this product.');
        $('.progress-bar', $product).css('width', '95%');
        if($('.quantity', $product).length > 0) {
        	$('.quantity', $product).attr('max', 100);
        }
      } else {
      	$('.progress-wrapper', $product).addClass('uk-hidden');
      }
    } else {
      if (variant.available == true) {
        $('.progress-wrapper', $product).removeClass('uk-hidden');
        $('.stock-qty-wrapper', $product).empty().append(hurry_only+' <span id="stock-qty">'+inventory_quantity+' '+pluralize_product+'</span> '+products_left_in_stock);
        $('.progress-bar', $product).css('width', inventory_quantity+'%');
        if($('.quantity', $product).length > 0) {
          $('.quantity', $product).attr('max', inventory_quantity);
          if($('.quantity', $product).val() > inventory_quantity) {
          	$('.quantity', $product).val(inventory_quantity);
          }
        }
      } else {
      	$product.find('.progress-wrapper').addClass('uk-hidden');
      }
    }
    //END Manage Inventory
  }
  
  if (variant && variant.featured_image && $product.is(":visible")) {
    var $mainImages = $('.main-images', $product);
    $mainImages.each(function() {
      var $slider = $(this);
      
      if ($slider.is(":visible")) {
        var index = $product.find('[data-image-id="' + variant.featured_image.id + '"]').data('index');
        $slider.slick('slickGoTo', parseInt(index), true);
      }
    });
  }
  
  if(variant) {
    if(variant.sku != '') {
      $('.sku span', $product).text(variant.sku);
      $('.sku', $product).removeClass('uk-hidden');
    } else {
      $('.sku', $product).addClass('uk-hidden');
    }
    
    
      for (var i=0,length=variant.options.length; i<length; i++) {
        var radioButton = $productForm.find('.swatch[data-option-index="' + escape(i) + '"] :radio[value="' + variant.options[i].replace(/\"/g,'\\"') +'"]');
        if (radioButton.length) {
          radioButton.get(0).checked = true;
        }
      }
    
  }
  
  var save = 'Save';
  var sale = 'Sale';
  var sold = 'Sold out';
  
  if(variant.price < variant.compare_at_price){
      $('.was_price', $product).html('<span class="money">' + Shopify.formatMoney(variant.compare_at_price, $productForm.data('money-format')) + '</span>');
      $('.savings', $product).html("Translation missing: en.products.product.savings" + ' ' + parseInt(((variant.compare_at_price - variant.price) * 100) / variant.compare_at_price) + '% (' + '<span class="money">' + Shopify.formatMoney(variant.compare_at_price - variant.price, $productForm.data('money-format')) + '</span>)');
      $('.current_price', $product).parent().addClass('sale');
    } else {
      $('.was_price', $product).html('');
      $('.savings', $product).html('');
      $('.current_price', $product).parent().removeClass('sale');
    }
  
  if (variant && variant.available == true) {
    if (variant.price > 0) {
      $('.current-price', $product).empty().append('<span class="money">' + Shopify.formatMoney(variant.price, $productForm.data('money-format')) + '</span>').show();
    } else {
      $('.current-price', $product).empty().append("FREE").show();
    }
    $('.sold-out', $product).addClass('uk-hidden');
    $('.current-price', $product).removeClass('uk-hidden');
    if(variant.price < variant.compare_at_price){
      var amount = variant.compare_at_price - variant.price;
      $('.was-price', $product).empty().append('<span class="money">' + Shopify.formatMoney(variant.compare_at_price, $productForm.data('money-format')) + '</span>').removeClass('uk-hidden');
      $('.sale.amount', $product).empty().append('<span class="money">' + save+' '+Shopify.formatMoney(amount)+ '</span>').removeClass('uk-hidden');
      $('.sale.savings', $product).empty().append(save+' '+parseInt(((variant.compare_at_price - variant.price) * 100) / variant.compare_at_price)+'%').removeClass('uk-hidden');
      $('.sale.text', $product).empty().append(sale).removeClass('uk-hidden');
    } else {
      $('.was-price', $product).addClass('uk-hidden');
      $('.sale.amount', $product).addClass('uk-hidden');
      $('.sale.savings', $product).addClass('uk-hidden');
      $('.sale.text', $product).addClass('uk-hidden');
    }
    
    $('.add-to-cart', $product).removeAttr('disabled').find('span.text').text($('.add-to-cart', $product).data('add-text'));
    $('.shopify-payment-button', $product).show();
  } else {
    $('.sold-out', $product).removeClass('uk-hidden');
    $('.was-price', $product).addClass('uk-hidden');
    $('.sale.amount', $product).addClass('uk-hidden');
    $('.sale.savings', $product).addClass('uk-hidden');
    $('.sale.text', $product).addClass('uk-hidden');
    $('.current-price', $product).addClass('uk-hidden');
    
    $('.add-to-cart', $product).attr('disabled', 'disabled').find('span.text').text($('.add-to-cart', $product).data('sold-text'));
    $('.shopify-payment-button', $product).hide();
  }
  
  
}